/**
 * Checks to see if the given storage is available for use. Uses the method
 * outlined here: https://gist.github.com/Fluidbyte/4718380#gistcomment-1758829
 *
 * @param {string} storage The type of storage to check for
 * @return {Boolean} True if the storage is available
 *
 * @public
 * @author Alex Kasemir
 */
const storageAvailable = (storage) => {
  try {
    const x = `__storage_test__`;
    window[storage].setItem(x, x);
    setTimeout(() => window[storage].removeItem(x), 400); // For FF
    return true;
  } catch (e) {
    return false;
  }
};

/** @component */
export default storageAvailable;
